import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserRemoveSubtractSvg = function UserRemoveSubtractSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.736 4.249a4.68 4.68 0 0 0-3.251 1.302 4.37 4.37 0 0 0-1.347 3.142 4.37 4.37 0 0 0 1.347 3.143 4.68 4.68 0 0 0 3.25 1.302 4.68 4.68 0 0 0 3.252-1.302 4.37 4.37 0 0 0 1.346-3.143 4.37 4.37 0 0 0-1.346-3.142 4.68 4.68 0 0 0-3.251-1.302M8.46 6.494a3.28 3.28 0 0 1 2.276-.912c.853 0 1.672.328 2.275.912a3.06 3.06 0 0 1 .943 2.2 3.06 3.06 0 0 1-.943 2.2 3.28 3.28 0 0 1-2.275.91 3.28 3.28 0 0 1-2.276-.91 3.06 3.06 0 0 1-.943-2.2c0-.826.34-1.617.943-2.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.38 17.491v1.425h8.505v1.333H2v-3.547l.354-.191a17.16 17.16 0 0 1 8.152-2.04c2.422 0 4.727.497 6.808 1.391l-.56 1.219a15.8 15.8 0 0 0-6.248-1.276h-.001a15.76 15.76 0 0 0-7.126 1.686"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.724 18.916H22v1.333h-8.276z"
  }));
};
export var UserRemoveSubtract = function UserRemoveSubtract(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserRemoveSubtractSvg
  }));
};